import { ActionDropdown, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Box, Text } from 'native-base';
import React, { useMemo } from 'react';

import { Option } from '../Statements/Header';

interface SelectTypeProps {
  title: string;
  options: Option[];
  onValueChange: (value: string) => void;
  selectedValue: string;
  isDisabled?: boolean;
  isLoading?: boolean;
}

export const SelectType: React.FC<SelectTypeProps> = ({
  onValueChange,
  selectedValue,
  options,
  title,
  isDisabled = false,
  isLoading = false,
}) => {
  const selectItemList = useMemo(
    () =>
      options?.map((option) => (
        <ActionDropdown.Item
          key={option.label}
          onPress={() => onValueChange(option.value)}
          label={option.label}
        />
      )),
    []
  );

  if (options.length === 0) {
    return null;
  }

  return (
    <HStack space={Spacing['inline.nano']} alignItems="center" flex={1}>
      <Text
        variant="regular"
        fontSize={Typography['fontsize.md']}
        color="neutral.medium"
        {...((isDisabled || isLoading) && { color: 'neutral.light' })}>
        {title}
      </Text>
      <Box maxW="300px" flex={1}>
        <ActionDropdown
          triggerProps={{ isDisabled }}
          triggerLabel={selectedValue}
          isLoading={isLoading}
          triggerLabelColor="neutral.black">
          {selectItemList}
        </ActionDropdown>
      </Box>
    </HStack>
  );
};
